export const TEST_IDS = {
  CREATE_FORM: 'api-key-create-form',
  NAME_INPUT: 'api-key-name-input',
  CREATE_BTN: 'api-key-create-btn',
  KEY_TABLE: 'api-key-table',
  KEY_ROW: 'api-key-row',
  REVOKE_BTN: 'api-key-revoke-btn',
  NEW_KEY_MODAL: 'api-key-new-modal',
  NEW_KEY_VALUE: 'api-key-new-value',
  COPY_BTN: 'api-key-copy-btn',
  EMPTY_STATE: 'api-key-empty-state',
  DOCS_PANEL: 'api-key-docs-panel',
  SYNC_EXAMPLE: 'api-key-docs-sync-example',
  docsResponse: (endpointId) => `api-key-docs-response-${endpointId}`,
};
